angular.module('impactx.basket').controller('EditFreeFormOfferCtrl', [
    '$scope',
    'dataGen',
    '$mdDialog',
    'TranslationService',
    'basketItemGroupId',
    'headerId',
    '$mdToast',
    '$context',
    '$securityManager',
    'OutsourcedCommentSaveService',
    'ToastService',
    'hideOrderData',
    'DownloadService',
    '$timeout',
    'FileHelperService',
    '$q',
    'lotId',
    'supplierId',
    'product',
    'FreeFormDialogService',
    'allowBANF',
    'onlyBANF',
    'AppConfiguration',
    '$rootScope',
    EditFreeFormOfferCtrl
]);

function EditFreeFormOfferCtrl($scope, dataGen, $mdDialog, TranslationService, basketItemGroupId, headerId, $mdToast,
                               $context, $securityManager, OutsourcedCommentSaveService, ToastService, hideOrderData,
                               DownloadService, $timeout, FileHelperService, $q, lotId, supplierId,
                               product, FreeFormDialogService, allowBANF, onlyBANF, AppConfiguration, $rootScope) {
    var self = this;
    var typeComplete = FreeFormDialogService.typeComplete;
    var typeItems = FreeFormDialogService.typeItems;
    $scope.showDescription = AppConfiguration.get("useDescriptionInFreeformOfferDialog");
    $scope.typeComplete = typeComplete;
    $scope.typeItems = typeItems;
    self.freeformOfferLotSelect = FreeFormDialogService.freeformOfferLotSelect;
    $scope.dataInProgress = {value: false};
    $scope.lotId = lotId ? Number(lotId) : 0;
    $scope.supplierId = supplierId ? Number(supplierId) : 0;
    $scope.hideOrderData = hideOrderData;
    $scope.basketItemGroupId = basketItemGroupId;
    $scope.supplierAndContractArray = [];
    $scope.supplierAndLotArray = [];
    $scope.typeSelected = 0;
    $scope.trns = {};
    //set data to prevent problem with multiple async autocompletes in ng-if
    $scope.data = {};
    $scope.supplierControl = {};
    $scope.lotAndContractControl = {};
    var oldSupplierSelection = {};
    var numberOfMaterialGroupMappingsInProgress = 0;
    var uploadInProgress = false;
    $scope.currentlyImportingExcel = false;
    $scope.errorList = [];
    $scope.sumHasChanged = false;
    $scope.isBANF = onlyBANF;
    var supplierNoTimeOut;
    var contractReadOnly = false;
    var lotReadOnly = false;

    var now = new Date();
    $scope.minDate = new Date(now.getFullYear(), now.getMonth(), now.getDate());

    self.markSumAsChanged = function (value) {
        $scope.sumHasChanged = value;
    };

    if (basketItemGroupId <= 0) {
        $scope.wizardIndex = 0;
        dataGen.getData($scope, {proId: (product ? product.id : 0), lotId: $scope.lotId}, "/basket/freeformoffer/view").then(function () {
            $scope.trns.save = TranslationService.get("save");
            $scope.trns.abort = TranslationService.get("abort");
            $scope.trns.back = TranslationService.get("back");
            $scope.trns.required = TranslationService.get('required');
            $scope.trns.noSelectedItemMessage = TranslationService.get('noSelectedItemMessage');
            $scope.trns.zeroNotAllowed = TranslationService.get("zeroNotAllowed");
            $scope.trns.noDigitsAllowed = TranslationService.get("noDigitsAllowed");
            $scope.trns.updateSum = TranslationService.get("updateSum");
            contractReadOnly = $scope.data.contract.readOnly;
            lotReadOnly = $scope.data.lot.readOnly;
            FreeFormDialogService.addWatchSelection($scope, self.forward);
        });
    }
    else {
        var dataObj = {headerId: headerId, basketItemGroupId: basketItemGroupId};

        $scope.wizardIndex = 2;
        dataGen.getData($scope, dataObj, "/basket/freeformoffer/items/view").then(function () {
            $scope.trns.save = TranslationService.get("save");
            $scope.trns.abort = TranslationService.get("abort");
            $scope.trns.back = TranslationService.get("back");
            $scope.trns.required = TranslationService.get('required');
            $scope.trns.noSelectedItemMessage = TranslationService.get('noSelectedItemMessage');
            $scope.trns.zeroNotAllowed = TranslationService.get("zeroNotAllowed");
            $scope.trns.noDigitsAllowed = TranslationService.get("noDigitsAllowed");
            $scope.trns.updateSum = TranslationService.get("updateSum");
            for (var i = 0; i < $scope.data.requestItems.length; i++) {
                $scope.data.requestItems[i].hasValues = true;
            }
            pushTemplateItem();
            self.recalculateItemsOffer();
        });
    }

    function pushTemplateItem() {
        if (!$scope.data.isRFQIRelated) {
            $scope.data.requestItems.push(JSON.parse(JSON.stringify($scope.data.templateItem)));
        }
    }


    var resetSelectArray = function () {
        $scope.supplierAndContractArray = [];
        $scope.supplierAndLotArray = [];
        if ($scope.lotId) {
            $scope.supplierAndContractArray.push({field: 'lotId', value: $scope.lotId});
            $scope.supplierAndLotArray.push({field: 'lotId', value: $scope.lotId});
        }
        if ($scope.supplierId) {
            $scope.supplierAndContractArray.push({field: 'supplierId', value: $scope.supplierId});
            $scope.supplierAndLotArray.push({field: 'supplierId', value: $scope.supplierId});
        }
        if (allowBANF) {
            $scope.supplierAndContractArray.push({field: 'allowBANF', value: allowBANF});
        }
        if (onlyBANF) {
            $scope.supplierAndContractArray.push({field: 'onlyBANF', value: onlyBANF});
        }
    };
    resetSelectArray();

    self.supplierSelected = function (selected) {
        if ($scope.wizardIndex === 0) {
            resetSelectArray();
            $scope.supplierAndContractArray.push({field: 'supplierId', value: selected ? selected.id : 0});
            $scope.supplierAndContractArray.push({
                field: 'contractId',
                value: $scope.data.contract.selected ? $scope.data.contract.selected.id : 0
            });
            if (!$scope.data.contract.selected && selected) {
                $scope.lotAndContractControl.getEntries($scope.supplierAndContractArray, true);
            }
        }
    };

    self.contractSelected = function (selected) {
        if ($scope.wizardIndex === 0) {
            resetSelectArray();
            if (!$scope.supplierId) {
                $scope.supplierAndContractArray.push({
                    field: 'supplierId',
                    value: $scope.data.supplier.selected ? $scope.data.supplier.selected.id : $scope.supplierId
                });
            }
            $scope.supplierAndContractArray.push({field: 'contractId', value: selected ? selected.id : 0});
            if (!$scope.data.supplier.selected && selected) {
                $scope.supplierControl.getEntries($scope.supplierAndContractArray, true);
            }

            if (selected) {
                $scope.isBANF = selected.hasSpecialFlag;
            }

        }
    };

    self.lotSelected = function (selected) {
        if ($scope.wizardIndex === 0) {
            resetSelectArray();
            if (!$scope.supplierId) {
                $scope.supplierAndLotArray.push({
                    field: 'supplierId',
                    value: $scope.data.supplier.selected ? $scope.data.supplier.selected.id : 0
                });
            }
            $scope.supplierAndLotArray.push({field: 'lotId', value: selected ? selected.id : 0});
            if (!$scope.data.supplier.selected && selected) {
                $scope.supplierControl.getEntries($scope.supplierAndLotArray, true);
            }
        }
    };

    self.supplierForLotSelected = function (selected) {
        if ($scope.wizardIndex === 0) {
            resetSelectArray();
            $scope.supplierAndLotArray.push({field: 'supplierId', value: selected ? selected.id : 0});
            if (!$scope.lotId) {
                $scope.supplierAndLotArray.push({
                    field: 'lotId',
                    value: $scope.data.lot.selected ? $scope.data.lot.selected.id : 0
                });
            }
            if (!$scope.data.lot.selected && selected) {
                $scope.lotAndContractControl.getEntries($scope.supplierAndLotArray, true);
            }
        }
    };

    self.cancel = function () {
        $mdDialog.cancel();
    };

    self.save = function () {
        $mdDialog.hide();
    };

    self.forward = function (selectedType) {
        $scope.wizardIndex = selectedType;
        $scope.dataInProgress.value = true;
        if ($scope.wizardIndex === typeComplete) {
            self.getDataForCompleteOffer();
        }
        if ($scope.wizardIndex === typeItems) {
            self.getDataForItemOffer();
        }
    };

    self.back = function () {
        $scope.wizardIndex = 0;
        if (oldSupplierSelection) {
            $scope.data.supplier.selected = oldSupplierSelection;
        }
        $scope.data.contract.readOnly = contractReadOnly;
        $scope.data.lot.readOnly = lotReadOnly;
        $scope.ignoreWatchOnce = true;
        self.fireDialogUpdateEvent();
    };

    self.getDataForCompleteOffer = function () {
        if (impactX.isDefined($scope, 'data.contract.selected.id') && $scope.data.contract.selected.hasSpecialFlag) {
            $mdDialog.hide({freeformContract: $scope.data.contract.selected});
        }
        else {
            oldSupplierSelection = $scope.data.supplier.selected;
            var dataObj = {
                headerId: headerId,
                cscId: impactX.isDefined($scope, 'data.contract.selected.id'),
                lotId: $scope.lotId || impactX.isDefined($scope, 'data.lot.selected.id'),
                supplierOrOutletId: $scope.data.supplier.selected && $scope.data.supplier.selected.id ? $scope.data.supplier.selected.id : $scope.supplierId
            };

            var tempScope = {};
            dataGen.getData(tempScope, dataObj, "/basket/freeformoffer/complete/view").then(function () {
                $scope.dataInProgress.value = false;
                tempScope.data.requestItem.isFreeFormOffer = true;
                $scope.data.requestItem = tempScope.data.requestItem;
                $scope.data.showGross = tempScope.data.showGross;
                $scope.data.supplier = tempScope.data.supplier;
                $scope.data.outlet = tempScope.data.outlet;
                $scope.data.contractData = tempScope.data.contractData;
                self.fireDialogUpdateEvent();
            });
        }
    };

    self.getDataForItemOffer = function () {
        oldSupplierSelection = $scope.data.supplier.selected;
        var dataObj = {
            headerId: headerId,
            cscId: impactX.isDefined($scope, 'data.contract.selected.id'),
            lotId: $scope.lotId || impactX.isDefined($scope, 'data.lot.selected.id'),
            supplierOrOutletId: $scope.data.supplier.selected && $scope.data.supplier.selected.id ? $scope.data.supplier.selected.id : $scope.supplierId
        };

        var tempScope = {};
        dataGen.getData(tempScope, dataObj, "/basket/freeformoffer/items/view").then(function () {
            $scope.dataInProgress.value = false;
            $scope.trns.noArticleData = tempScope.trns.noArticleData;
            $scope.trns.uploadInProgress = tempScope.trns.uploadInProgress;
            $scope.trns.downloadTemplate = tempScope.trns.downloadTemplate;
            $scope.trns.uploadTemplate = tempScope.trns.uploadTemplate;
            $scope.trns.enterDate = tempScope.trns.enterDate;
            tempScope.data.templateItem.isFreeFormOffer = true;
            $scope.data.templateItem = tempScope.data.templateItem;
            $scope.data.isBANF = tempScope.data.isBANF;
            $scope.data.productGroup = tempScope.data.productGroup;
            $scope.data.purchaserGroups = tempScope.data.purchaserGroups;
            $scope.data.desiredVendors = tempScope.data.desiredVendors;
            $scope.data.deliveryDate = tempScope.data.deliveryDate;
            $scope.data.isCPDContract = tempScope.data.isCPDContract;
            $scope.data.cpdAddress = tempScope.data.cpdAddress;

            $scope.data.requestItems = [];
            $scope.$watch(function () {
                return $scope.data.requestItems.length
            }, function () {
                self.checkForErrors();
            });
            var classification = tempScope.data.templateItem.eClassSelection ? tempScope.data.templateItem.eClassSelection.selected : undefined;
            if (tempScope.data.templateItem.eClassSelection && tempScope.data.templateItem.eClassSelection.freeSelection) {
                classification = {id: 0, secondValue: tempScope.data.templateItem.eClassSelection.freeSelection.value}
            }
            self.updateMaterialGroupMapping(classification, $scope.data.templateItem).then(function () {
                pushTemplateItem();
                $scope.data.number = tempScope.data.number;
                $scope.data.name = tempScope.data.name;
                $scope.data.comments = tempScope.data.comments;
                $scope.data.showGross = tempScope.data.showGross;
                $scope.data.supplier = tempScope.data.supplier;
                $scope.data.outlet = tempScope.data.outlet;
                $scope.data.contractData = tempScope.data.contractData;
                $scope.data.contract = tempScope.data.contract;
                $scope.data.deliveryDate = tempScope.data.deliveryDate;
                $scope.data.firstDeliveryDate = tempScope.data.firstDeliveryDate;
                $scope.data.lastDeliveryDate = tempScope.data.lastDeliveryDate;
                self.fireDialogUpdateEvent();
            });
        });
    };

    self.closeFunction = function () {
        $mdDialog.hide();
        ToastService.openStandardToast(TranslationService.get("saveSuccess"));
    };

    self.saveCompleteOffer = function (data) {
        var extractedComments = OutsourcedCommentSaveService.extractComments(data.requestItem);

        var dataObj = {
            data: data
        };
        dataGen.post({}, dataObj, "/basket/item/freeform/save").then(function (commentData) {
            if (commentData && commentData.data) {
                OutsourcedCommentSaveService.saveComments(commentData.data, extractedComments).then(self.closeFunction, self.closeFunction);
            }
            else {
                self.closeFunction();
            }
        }, function () {
            OutsourcedCommentSaveService.restoreComments(data.requestItem, extractedComments);
        });
    };

    self.updateGUI = function (index, markSumAsChanged) {
        if (index !== undefined) {
            var requestItem = $scope.data.requestItems[index];
            if (!requestItem.hasValues) {
                requestItem.hasValues = true;
                pushTemplateItem();
            }
        }
        if ($scope.wizardIndex === typeComplete) {
            self.recalculateCompleteOffer();
        }
        else {
            if (markSumAsChanged) {
                self.markSumAsChanged(true);
            }
        }
    };

    self.updateGUICurrency = function (index, selectedCurrency) {
        if (index !== undefined) {
            var requestItem = $scope.data.requestItems[index];
            if (!requestItem.hasValues) {
                requestItem.hasValues = true;
                pushTemplateItem();
            }
        }
        if (index > 0) {
            $scope.data.requestItems[index].price.currency.selected = selectedCurrency;
        }
        else {
            $scope.data.requestItem.price.currency.selected = selectedCurrency;
        }

        if ($scope.wizardIndex === typeComplete) {
            self.recalculateCompleteOffer();
        }
        else {
            self.markSumAsChanged(true);
        }
    };

    self.saveItemsOffer = function (data) {
        var extractedComments = OutsourcedCommentSaveService.extractComments(data);

        var dataObj = {
            itemsData: {
                number: $scope.data.number,
                name: $scope.data.name,
                requestItems: $scope.data.requestItems,
                outlet: $scope.data.outlet,
                deliveryDate: $scope.data.deliveryDate,
                firstDeliveryDate: $scope.data.firstDeliveryDate,
                lastDeliveryDate: $scope.data.lastDeliveryDate,
                isRFQIRelated: $scope.data.isRFQIRelated,
                productGroup: $scope.data.productGroup,
                purchaserGroups: $scope.data.purchaserGroups,
                desiredVendors: $scope.data.desiredVendors,
                isBANF: $scope.data.isBANF,
                isCPDContract: $scope.data.isCPDContract,
                cpdAddress: $scope.data.cpdAddress
            }
        };
        dataGen.postAsForm({}, dataObj, "/basket/freeformoffer/items/save").then(function (commentData) {
            self.closeFunction();
            if (commentData && commentData.data) {
                OutsourcedCommentSaveService.saveComments(commentData.data, extractedComments, !$scope.data.isBANF).then(self.closeFunction, self.closeFunction);
            }
            else {
                self.closeFunction();
            }
        }, function () {
            OutsourcedCommentSaveService.restoreComments(data, extractedComments);
        });
    };

    self.recalculateCompleteOffer = function () {
        var items = [];
        var tempScope = {};
        var copiedItem = JSON.parse(JSON.stringify($scope.data.requestItem));
        copiedItem.comments = null;
        items.push(copiedItem);
        dataGen.postAsForm(tempScope, {items: items}, "/basket/freeformoffer/summary").then(function () {
            $scope.summary = tempScope.data;
        });
    };

    self.recalculateItemsOffer = function () {
        var tempScope = {};
        dataGen.postAsForm(tempScope, {items: $scope.data.requestItems}, "/basket/freeformoffer/summary").then(function () {
            $scope.summary = tempScope.data;
            self.markSumAsChanged(false);
        });
    };

    self.removeLine = function (index) {
        $scope.data.requestItems.splice(index, 1);
        self.markSumAsChanged(true);
    };

    self.downloadTemplate = function () {
        DownloadService.openDownloadPost('/basket/freeformoffer/items/template')
    };

    self.uploadTemplate = function () {
        angular.element(document.querySelector('#uploadTemplate')).on('change', self.handleFileSelect);
        $timeout(function () {
            angular.element(document.querySelector('#uploadTemplate')).click();
        });
    };

    self.handleFileSelect = function (evt) {
        var file = evt.currentTarget.files[0];
        $(this).val("");
        self.handleFile(evt, file);
    };

    self.handleFile = function (evt, file) {
        if (file) {
            if (!FileHelperService.checkAllowedFileWithError(file.name)) {
                return;
            }
            uploadInProgress = true;
            $scope.$evalAsync(function () {
                self.addAttachmentStream(file);
            });
        }
    };

    self.handlePositionImportData = function (data) {
        if (data.data && data.data.itemList) {
            $scope.data.requestItems.splice($scope.data.requestItems.length - 1, 1);
            for (var i = 0; i < data.data.itemList.length; i++) {
                var requestItem = data.data.itemList[i];
                if (!requestItem.hasValues) {
                    requestItem.hasValues = true;
                }
                numberOfMaterialGroupMappingsInProgress++;
                var classification = requestItem.eClassSelection ? requestItem.eClassSelection.selected : undefined;
                if (requestItem.eClassSelection && requestItem.eClassSelection.freeSelection) {
                    classification = {id: 0, secondValue: requestItem.eClassSelection.freeSelection.value}
                }
                self.updateMaterialGroupMapping(classification, requestItem).then(function () {
                    numberOfMaterialGroupMappingsInProgress--;
                });
                $scope.data.requestItems.push(requestItem);
            }
            pushTemplateItem();
            self.recalculateItemsOffer();
        }
        uploadInProgress = false;
    };

    $scope.$watch(function () {
        return uploadInProgress
    }, function (newVal) {
        if (!newVal && numberOfMaterialGroupMappingsInProgress <= 0) {
            $scope.currentlyImportingExcel = false;
        }
        if (newVal) {
            $scope.currentlyImportingExcel = true;
        }
        self.checkForErrors();
    });

    $scope.$watch(function () {
        return numberOfMaterialGroupMappingsInProgress
    }, function (newVal, oldValue) {
        if (newVal === 0 && !uploadInProgress) {
            $scope.currentlyImportingExcel = false;
        }
        self.checkForErrors();
    });

    self.addAttachmentStream = function (file) {
        var data = {
            file: file,
            bkhId: headerId,
            cscId: $scope.data.contract.selected.id
        };

        dataGen.uploadFile(data, '/basket/freeformoffer/items/import', true).then(function (data) {
            self.handlePositionImportData(data);
        }, function (data) {
            self.handlePositionImportData(data);
        });
    };

    this.updateMaterialGroupMapping = function (selected, requestItem) {
        var defer;
        if (!requestItem) {
            requestItem = $scope.data.requestItem;
        }
        if (requestItem.eClassMaterialGroupMapping) {
            if (!selected) {
                requestItem.eClassMaterialGroupMapping.selected = null;
                defer = $q.defer();
                defer.resolve();
                return defer.promise;
            }
            else {
                var tempScope = {};
                return dataGen.getData(tempScope, {
                    eClass: selected.secondValue,
                    sapConfigId: requestItem.sapConfigId
                }, "/basket/freeform/materialgroupmappingforeclass").then(function () {
                    requestItem.eClassMaterialGroupMapping.selected = tempScope.data.newMapping;
                });
            }
        }
        else {
            defer = $q.defer();
            defer.resolve();
            return defer.promise;
        }
    };

    this.updateMaterialGroupMappingAndGUI = function (index, requestItem, selected) {
        var defer = self.updateMaterialGroupMapping(selected, requestItem);
        self.updateGUI(index);
        return defer;
    };

    self.checkForErrors = function () {
        $scope.errorList.length = 0;
        if ($scope.data.requestItems && $scope.data.requestItems.length === 1) {
            $scope.errorList.push($scope.trns.noArticleData);
        }
        if ($scope.currentlyImportingExcel) {
            $scope.errorList.push($scope.trns.uploadInProgress);
        }
    };

    self.getEClassFromSupplierNoForItems = function (index) {
        if (supplierNoTimeOut) {
            $timeout.cancel(supplierNoTimeOut);
        }
        supplierNoTimeOut = $timeout(function () {
            if ($scope.data.requestItems[index].supplierNo.value && $scope.data.requestItems[index].eClassSelection) {
                dataGen.getData({}, {
                        supplierNo: $scope.data.requestItems[index].supplierNo.value,
                        cscId: $scope.data.contract.selected.id
                    },
                    "/basket/freeformoffer/items/eclassfromproduct").then(function (data) {
                    if (data.data) {
                        $scope.data.requestItems[index].eClassSelection.selected = data.data;
                        $scope.data.requestItems[index].eClassSetFromProduct = true;
                    }
                    $scope.data.requestItems[index].eClassRequestInProgress = false;
                });
            }
            else {
                $scope.data.requestItems[index].eClassRequestInProgress = false;
            }

            supplierNoTimeOut = null;
        }, 500);
        $scope.data.requestItems[index].eClassSetFromProduct = false;
        $scope.data.requestItems[index].eClassRequestInProgress = true;
        self.updateGUI(index);
    };

    $scope.initialized = true;

    self.showOption = function (type) {
        return FreeFormDialogService.showOption($scope, type);
    }

    self.currencyPopupChange = function (index, selectedCurrency) {
        $scope.data.requestItems[index].price.currency.selected = selectedCurrency;
        if ($scope.wizardIndex === typeComplete) {
            self.recalculateCompleteOffer();
        }
        else {
            self.markSumAsChanged(true);
        }
    };

    $scope.onProductGroupSelect = function (selected) {
        dataGen.getData({}, {prgId: selected.id, cscId: $scope.data.contract.selected.id}, "/basket/prg/changed").then(function(result) {
            if (result && result.data) {
                $scope.data.purchaserGroups = result.data;
                if (impactX.isDefined($scope, "data.purchaserGroups.entries.length") === 1 && $scope.data.purchaserGroups.showMust) {
                    $scope.data.purchaserGroups.selected = $scope.data.purchaserGroups.entries[0];
                }
            }
        });
    };

    self.fireDialogUpdateEvent = function () {
        $rootScope.$broadcast('$mdDialogUpdate');
    }
}
